var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0553 8.43712C10.0553 8.43712 10.9836 2.95296 7.18192 0.571289C7.06759 2.47738 6.14688 4.24456 4.65026 5.43046C3.02442 6.85962 -0.0322429 10.0713 0.000257102 13.4963C-0.0215285 16.4831 1.65097 19.2243 4.31692 20.5713C4.41126 19.2359 5.03933 17.9948 6.05942 17.128C6.92408 16.4633 7.48531 15.4789 7.61692 14.3963C9.89313 15.606 11.3655 17.9235 11.4936 20.498V20.5146C14.0068 19.3609 15.6607 16.8952 15.7744 14.1321C16.0444 10.913 14.2811 6.53879 12.7178 5.10879C12.1276 6.42651 11.2112 7.57202 10.0553 8.43712Z",
    fill: "#E9615F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.634e4dd00111843f113cc65e7156f6c2.svg";
export { ForwardRef as ReactComponent };